
import { type ReactNode, type MouseEvent, type CSSProperties } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  padding?: 'sm' | 'md' | 'lg';
  shadow?: boolean;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
  style?: CSSProperties;
  id?: string;  // ⭐ id prop 추가
}

export default function Card({
  children,
  className = '',
  padding = 'sm',
  shadow = true,
  onClick,
  style,
  id,  // ⭐ id 추가
}: CardProps) {
  const paddingClasses = {
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8'
  };

  const shadowClass = shadow ? 'shadow-sm' : '';

  return (
    <div
      id={id}
      className={`bg-white rounded-lg border border-gray-100 ${paddingClasses[padding]} ${shadowClass} ${className}`}
      onClick={onClick}
      style={style}
    >
      {children}
    </div>
  );
}
